// extracted by mini-css-extract-plugin
module.exports = {"inline":"child_inline__3rEyX"};